/**
 * @description A list of seccon personnel fields and descriptions
 */

const list = [
  {
    field: 'activeDirectoryUserId',
    description: 'The username associated with your SSO provider (windows ID, Okta, etc.).'
  },
  {
    field: 'agencyId',
    description: 'Various federal agencies identification codes.'
  },
  {
    field: 'alienRegistrationNumber',
    description: '7-9 digit UCIS number found on immigration documents.'
  },
  {
    field: 'birthCity',
    description: 'The city where the personnel was born.'
  },
  {
    field: 'birthCountry',
    description: 'The country where the personnel was born.'
  },
  {
    field: 'birthDate',
    description: 'The day the personnel was born.'
  },
  {
    field: 'birthState',
    description: 'The state where the personnel was born.'
  },
  {
    field: 'citizenshipCountry',
    description: 'The country of citizenship.'
  },
  {
    field: 'citizenshipDate',
    description: 'The date of citizenship.'
  },
  {
    field: 'citizenshipType',
    description: 'The type of citizenship (born in the country, naturalized citizen, etc.).'
  },
  {
    field: 'clientFso',
    description: 'True/False value, personnel identified as FSO.'
  },
  {
    field: 'clientManager',
    description: 'True/False value, personnel who will be given higher administrative privileges to the system.'
  },
  {
    field: 'contingentOfferLetterSignedDate',
    description: 'Date of contingent offer letter.'
  },
  {
    field: 'costCenter',
    description: 'Cost center tracking for personnel.'
  },
  {
    field: 'dissPrimaryHierarchyAccountManager',
    description: 'DISS hierarchy level for personnel.'
  },
  {
    field: 'dissSecondaryHierarchyAccountManager',
    description: 'DISS hierarchy level for personnel.'
  },
  {
    field: 'dodEdiPn',
    description: 'DoD Identification Number, aka EDIPI (Electronic Data Interchange-Personal Identifier).'
  },
  {
    field: 'driversLicenseExpirationDate',
    description: 'The date on which the personnel\'s driver\'s license expires.'
  },
  {
    field: 'driversLicenseIssueDate',
    description: 'The date on which the personnel was issued a driver license.'
  },
  {
    field: 'driversLicenseNumber',
    description: 'The driver license number of the personnel. This number is found on the driver\'s license itself.'
  },
  {
    field: 'driversLicenseState',
    description: 'The state that issued the personnel driver\'s license.'
  },
  {
    field: 'emailAko',
    description: 'Army Knowledge Online (AKO), DoD community email address, and other joint military personnel.'
  },
  {
    field: 'emailCompany',
    description: 'The personnel\'s company (work) email address.'
  },
  {
    field: 'emailGovernment',
    description: 'The personnel\'s government email address.'
  },
  {
    field: 'emailPersonal',
    description: 'The personnel\'s personal email address.'
  },
  {
    field: 'emailPreferred',
    description: 'The preferred email address for Sec-Con to send email notifications to. The value must be one of the following: "AKO Email", "Company Email", "Government Email", or "Personal Email".'
  },
  {
    field: 'employeeNumber',
    description: 'Employee ID.'
  },
  {
    field: 'employmentStatus',
    description: 'Personnel\'s employment status (Active, Inactive, Contingent Hire, Suspended).'
  },
  {
    field: 'employmentType',
    description: 'Personnel\'s employment type (1099 Consultant, W2, Subcontractor, K1, Intern).'
  },
  {
    field: 'eyeColor',
    description: 'Personnel\'s eye color.'
  },
  {
    field: 'facilityCode',
    description: 'The CAGE Code of the facility where the personnel reports. To create new personnel using the sync tool, this value must be mapped and present in the spreadsheet.'
  },
  {
    field: 'firstName',
    description: 'The personnel\'s legal first name.'
  },
  {
    field: 'foreignPassport',
    description: 'True/False value, whether personnel holds a foreign passport.'
  },
  {
    field: 'foreignPassportCountry',
    description: 'The country where which the foreign passport belongs.'
  },
  {
    field: 'foreignPassportExpirationDate',
    description: 'The date on which the personnel\'s foreign passport expires.'
  },
  {
    field: 'foreignPassportIssueDate',
    description: 'The date on which the personnel\'s foreign passport was issued.'
  },
  {
    field: 'gender',
    description: 'The personnel\'s identifying gender.'
  },
  {
    field: 'hairColor',
    description: 'The personnel\'s hair color.'
  },
  {
    field: 'height',
    description: 'The physical height of the personnel.'
  },
  {
    field: 'hireDate',
    description: 'The date on which the personnel was hired.'
  },
  {
    field: 'homeAddress',
    description: 'The personnel\'s home address.'
  },
  {
    field: 'homeAddress2',
    description: 'The secondary address line for a personnel\'s home address. This is where items like apartment number, condo number, etc. would appear.'
  },
  {
    field: 'homeCity',
    description: 'The city where the personnel\'s home address is located.'
  },
  {
    field: 'homeState',
    description: 'The state where the personnel\'s home address is located.'
  },
  {
    field: 'homeZip',
    description: 'The zip code of the personnel\'s home address.'
  },
  {
    field: 'insiderThreatOfficial',
    description: 'True/False value, states if the personnel is an Insider Threat Official.'
  },
  {
    field: 'insiderThreatWorkingGroupMember',
    description: 'True/False value, states if the personnel is a member of the Insider Threat Working Group.'
  },
  {
    field: 'jobTitle',
    description: 'The job title of the personnel.'
  },
  {
    field: 'kmp',
    description: 'True/False value, states if the personnel is a key management personnel.'
  },
  {
    field: 'kmpExcluded',
    description: 'True/False value, states if the personnel is an excluded key management personnel.'
  },
  {
    field: 'kmpExclusionDate',
    description: 'If the personnel is key management personnel and they are excluded, this is the date on which the key management exclusion occurred.'
  },
  {
    field: 'kmpOwnership',
    description: 'If the personnel is key management personnel, this is the percentage of ownership they hold.'
  },
  {
    field: 'kmpType',
    description: 'The type of key management personnel (temporary or permanent).'
  },
  {
    field: 'lastName',
    description: 'The surname of the personnel.'
  },
  {
    field: 'maritalStatus',
    description: 'The marital status of the personnel.'
  },
  {
    field: 'middleName',
    description: 'The government middle name of the personnel.'
  },
  {
    field: 'naturalizationDate',
    description: 'Date of naturalization for citizenship.'
  },
  {
    field: 'naturalizationNumber',
    description: '8-digit USCIS number on immigration documents.'
  },
  {
    field: 'nonUSCitizenshipRenunciationDate',
    description: 'Renunciation date of non-US Citizenship.'
  },
  {
    field: 'oconus',
    description: 'True/False value, if personnel employment location is Outside of Continental U.S.'
  },
  {
    field: 'optOutAccountGeneration',
    description: 'Determines if the generated user workflow should create a user account for the personnel record. If optOutAccountGeneration is false, a user account will not be created for this personnel.'
  },
  {
    field: 'passportExpirationDate',
    description: 'The date on which the personnel\'s passport expires.'
  },
  {
    field: 'passportIssueDate',
    description: 'The date on which the personnel\'s passport was issued.'
  },
  {
    field: 'passportNumber',
    description: 'The personnel\'s passport number issued on their passport document.'
  },
  {
    field: 'passportType',
    description: 'The type of passport the personnel holds.'
  },
  {
    field: 'phoneCell',
    description: 'The personnel\'s cell phone number.'
  },
  {
    field: 'phoneCompany',
    description: 'The personnel\'s company phone number.'
  },
  {
    field: 'phoneHome',
    description: 'The personnel\'s home phone number.'
  },
  {
    field: 'phonePreferred',
    description: 'The personnel\'s preferred phone number for being contacted. The value must be one of the following: "Cell Phone", "Company Phone" or "Home Phone".'
  },
  {
    field: 'programManager',
    description: 'True/False value, states if the personnel is a program manager who will be assigned to oversee a contract(s).'
  },
  {
    field: 'pssn',
    description: 'Personnel\'s Pseudo Social Security Number issued by DoD.'
  },
  {
    field: 'race',
    description: 'The race of the personnel.'
  },
  {
    field: 'secondCitizenshipCountry',
    description: 'If the personnel is a dual citizen, this field represents the second country they hold citizenship.'
  },
  {
    field: 'seniorManagementOfficial',
    description: 'True/False value, states whether or not the personnel is a senior management official.'
  },
  {
    field: 'ssn',
    description: 'The Social Security Number of the personnel. This field must be mapped to a column from the spreadsheet to correctly create a mapping definition and sync personnel.'
  },
  {
    field: 'startDate',
    description: 'The date on which the personnel started working for a company.'
  },
  {
    field: 'subcontractorCompanyName',
    description: 'If the personnel is a subcontractor, this is the name of the company in which they are employed.'
  },
  {
    field: 'suffix',
    description: 'Personnel\'s suffix, if they have one.'
  },
  {
    field: 'supervisorEmail',
    description: 'The personnel\'s supervisor\'s email address.'
  },
  {
    field: 'supervisorName',
    description: 'The name of the personnel\'s supervisor.'
  },
  {
    field: 'supervisorPhone',
    description: 'The phone number of the personnel\'s supervisor.'
  },
  {
    field: 'terminationDate',
    description: 'The date on which the personnel was terminated.'
  },
  {
    field: 'weight',
    description: 'The physical weight of the personnel.'
  },
  {
    field: 'workLocation',
    description: 'The location in which the personnel works (onsite, remote, hybrid, etc.)'
  }
];

export default list;
